/**
 * Making a basket the server created the shopper's current one.
 *
 * <p>Accepting a quote creates a new basket on the server, holding exactly what
 * was quoted at the quoted prices. The storefront runtime keeps the current
 * basket's key in `localStorage` under this name and reads it when a page
 * loads (`@akademi/site-builder-runtime`, `portal/cartState.tsx`,
 * `TOKEN_STORAGE_KEY`); the runtime has no call to switch baskets, so the key
 * is written here and the basket page is loaded fresh. If the runtime's key
 * changes, this must change with it.
 */
export const BASKET_TOKEN_KEY = 'sorsy.cart.token';

/** Makes `token` the current basket; false when storage is blocked, and the basket cannot be switched. */
export function adoptBasket(token: string): boolean {
  try {
    window.localStorage.setItem(BASKET_TOKEN_KEY, token);
    return true;
  } catch {
    return false;
  }
}
